import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVbulletinComponent } from './simple-icons-vbulletin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVbulletinComponent ],
    exports:      [ SimpleIconsVbulletinComponent ],
    bootstrap:    []
})
export class SimpleIconsVbulletinModule {}
